import React from 'react';
import { componentService } from 'js/services/component.service';

export const CloseAccount = React.lazy(() => import(/* webpackChunkName: "close-account" */ './CloseAccount'));

// <hub2-close-account></hub2-close-account>
componentService.registerWebContentComponents({ CloseAccount });
